import { isAxiosError } from "axios";
import { toast } from "react-toastify";
import { toastOptions } from "../../config/toast";

export const useAxiosError = () => {
  const handleAxiosError = (error) => {
    if (isAxiosError(error)) {
      if(error.name == "CanceledError"){
        console.log("%cPetición cancelada","color:white;background-color:red")
      }
      else if (error.response) {
        //* RESPUESTA DEL ERROR
        toast.error(error.response.data.message || "Error en la solicitud", toastOptions);
      } else if (error.request) {
        //^EL SERVIDOR NO RESPONDIO
        toast.error("No se recibió respuesta del servidor", toastOptions);
      } else {
        //TODO ERROR EN LA CONFIGURACIÓN DE LA SOLICITUD
        toast.error("Error al configurar la solicitud", toastOptions);
      }
    } else {
      //!ERROR DESCONOCIDO
      toast.error("Hubo un error, intente mas tarde", toastOptions);
    }
  };

  return { handleAxiosError };
};
